// src/components/Landing.js
import React, { useState, useEffect } from 'react';
import './Landing.css';

function Landing() {
  const [fade, setFade] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setFade(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className={`landing ${fade ? 'fade-out' : ''}`}>
      {/* Video Background */}
      <video className="landing-video" autoPlay loop muted playsInline>
        <source src="/videos/Landing.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="landing-container">
        <h1>E2e tech A.I</h1>
        <p>A love letter to mathematics, computing and solutions.</p>
      </div>
    </section>
  );
}

export default Landing;